import { Route, Routes } from 'react-router-dom';
import { adminPaths } from '@/routes/paths';
import { AdminHomePage } from '@/modules/admin/pages/AdminHomePage';
import { AuditActivityPage } from '@/modules/admin/audit/AuditActivityPage';
import { UsersPage } from '@/modules/admin/pages/UsersPage';
import { RequirePermission } from '@/shared/components/RequirePermission';

export function AdminModule() {
  return (
    <Routes>
      <Route index element={<AdminHomePage />} />
      <Route
        path={adminPaths.users}
        element={
          <RequirePermission permission="users.manage">
            <UsersPage />
          </RequirePermission>
        }
      />
      <Route
        path={adminPaths.audit}
        element={
          <RequirePermission permission="audit.read">
            <AuditActivityPage />
          </RequirePermission>
        }
      />
    </Routes>
  );
}
